<div class="filter-toggle-group">
  <label *ngIf="label">{{ label }}</label>
  <div class="filter-toggle-group__options pb-3">
    <button
      *ngFor="let btn of options"
      class="btn btn-round btn-sm btn-outline-toggle"
      [ngClass]="'btn-outline-toggle-' + btn.class"
      [class.active]="isActive(btn.key)"
      (click)="onSelect(btn.key)">
      {{ btn.label }}
    </button>
  </div>
</div>
